import * as lib from '~/dependencies';
import { colors } from '~/layout';

type ContainerProps = {
  hasError: string;
};

type WarnMessageProps = {
  hasError: boolean;
};

type SendButtonProps = {
  disabled: boolean;
};

export const Container = lib.styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${(props: ContainerProps) =>
      props.hasError ? colors.red : colors.lightGray};
    border-radius: 8px;
    margin: 10px;
    box-shadow: 0px 0px 20px 0px #0000001A;
`;

export const Row = lib.styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 10px;
    margin: 10px;
`;

export const Input = lib.styled.textarea`
    resize: none;
    font-size: 16px;
    font-family: Nunito;
    line-height: 1.4;
    border: none;
    outline: none;
    /* direction: rtl; */
    text-align: left;
    unicode-bidi: plaintext;
    overflow-y: auto;  
    width: 100%;
    padding-left: 10px;
    color: ${colors.darkGray13};
    letter-spacing: 0.5px;

    max-height: 112.5px;
    transition: max-height 0.5s ease;

    ::placeholder {
        font-style: italic;
        opacity: 0.5;
    }

    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-track {
        background: ${colors.lightGray18};
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background: ${colors.lightBlue15};
        border-radius: 10px;
    }
`;

export const SendButton = lib.styled.button<SendButtonProps>`
    width: 45px;
    height: 34px;
    border: none;
    border-radius: 10px;
    background-color: ${(props: SendButtonProps) =>
      props.disabled ? colors.lightGray02 : colors.lightBlue15};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
`;

export const ArrowIcon = lib.styled(lib.ReactSVG)`
    svg {
        margin-top: 4px;
        width: 10px;
        height: 16px;  
    }
`;

export const WarnMessage = lib.styled.div<WarnMessageProps>`
    display: flex;
    flex-direction: column;
    background: ${colors.red08}; 
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    border-bottom: 1px solid ${(props: WarnMessageProps) =>
      props.hasError ? colors.red : 'none'};
    width: 100%;
    color: ${colors.red11};

    span {
        margin: 7px;
        font-size: 13px;
        text-align: center;
    }
`;

export const Bold = lib.styled.b``;

export const Button = lib.styled(lib.ReactSVG)`
    margin-left: 10px;
    margin-top: 3px;
    cursor: pointer;
`;
